import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { StackModule } from '../stack/stack.module';
import { MenuModule } from '../menu/menu.module';
import { DataDisplayModule } from './data-display.module';
import { BrandModule } from '../brand/brand.module';

import { CreditCardComponent } from './credit-card.component'

@NgModule({
  declarations: [CreditCardComponent],
  imports: [CommonModule, StackModule, DataDisplayModule, MenuModule, BrandModule],
  exports: [CreditCardComponent],
})
export class CreditCardModule {}